import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { BaseEntity } from "yt-ng-framework";

export class ResenjeZaGoView extends BaseEntity{
    constructor(){
        super();
    }

    Osoba:string = null;
    Broj:string = null;
    Datum:NgbDate = null;
    Godina:number = null;
    PravoNaGoBrojDana:number = null;



    Deserialize(input:any){
        this.ID=input.ID;
        this.Osoba = input.Osoba;
        this.Broj = input.Broj;
        this.Datum = input.Datum;
        this.PravoNaGoBrojDana = input.PravoNaGoBrojDana;
        return this;
    }

    Serialize(input:ResenjeZaGoView){
        return input;
    }
}